import { render } from "./trade_reward.vue?vue&type=template&id=cb286bb6"
import script from "./trade_reward.vue?vue&type=script&lang=js"
export * from "./trade_reward.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__